import React from "react";
import "./App.css";

const Heading = () => (
  <header className="App-header">
    <img
      className="App-logo"
      alt="Application logo"
      src="https://www.pinclipart.com/picdir/big/70-709405_c-clipart-letter-c-letter-c-in-a.png"
    />{" "}
    <span className="App-title">CYF Hotel</span>
  </header>
);
export default Heading;
